var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClientsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 21.7571C18 20.1658 17.3679 18.6397 16.2426 17.5144C15.1174 16.3892 13.5913 15.7571 12 15.7571C10.4087 15.7571 8.88258 16.3892 7.75736 17.5144C6.63214 18.6397 6 20.1658 6 21.7571",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 15.7571C14.2091 15.7571 16 13.9662 16 11.7571C16 9.54794 14.2091 7.75708 12 7.75708C9.79086 7.75708 8 9.54794 8 11.7571C8 13.9662 9.79086 15.7571 12 15.7571Z",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3.75708H5C3.89543 3.75708 3 4.65251 3 5.75708V19.7571C3 20.8617 3.89543 21.7571 5 21.7571H19C20.1046 21.7571 21 20.8617 21 19.7571V5.75708C21 4.65251 20.1046 3.75708 19 3.75708Z",
    stroke: "#1B1C1B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientsIcon);
export default __webpack_public_path__ + "static/media/clients-icon.c72a2407c9e2784598ff1199f285ee74.svg";
export { ForwardRef as ReactComponent };